// src/pages/ComingSoon.js
import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Comingsoon from "../../assets/images/comingsoon.svg";

const ComingSoon = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                textAlign: "center",
                backgroundColor: "background.default",
            }}
        >
            <Paper sx={{ padding: "60px", borderRadius: "20px" }}>
                <img src={Comingsoon} alt="ComingSoon" />

                <Typography variant="h3" component="h1" gutterBottom>
                    Coming Soon
                </Typography>
                <Typography variant="h5" component="h2" gutterBottom>
                    We're working hard to bring you something amazing!
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate("/dashboard")}
                    sx={{ mt: 4 }}
                >
                    Go back to Dashboard
                </Button>
            </Paper>
        </Box>
    );
};

export default ComingSoon;
